import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { housesSelectors } from '../../../../api/houses';
import Subtitle from '../../../../shared/ui/Subtitle';
import {
  useFilteredData,
  filterTypes,
} from '../../../../shared/packages/filter';
import { houseBySearch } from '../../../../shared/configs/filterOptions';
import { selectors, sliceKeys } from '../../../../model';
import ColListWrapper from '../../../../shared/ui/ColListWrapper';
import { ReactComponent as HotelIcon } from '../../../../../../resource/HotelIcon.svg';
import Item from '../../../../shared/ui/Item';
import NotFound from '../../../../shared/ui/NotFound';
import {
  createHouseNumber,
  createRoomLabelByCount,
  getHouseType,
} from '../../../../shared/packages/address';

const { selectHouses, selectSelectedSearch: selectSearch } =
  selectors[sliceKeys.houses];

const SelectedHousesList = ({ children }) => {
  const houses = useSelector(selectHouses);

  const search = useSelector(selectSearch);
  const filteredData = useFilteredData({
    data: houses,
    value: search,
    filterType: filterTypes.bySearch,
    options: houseBySearch,
  });

  const items = useMemo(
    () => housesSelectors.groupByStreet(filteredData),
    [filteredData]
  );

  return (
    <div className="colContentWrap">
      {children}
      {filteredData.length ? (
        <ColListWrapper grouped scrollable>
          {items.map(([key, data]) => (
            <MemoizedItem key={key} data={data} />
          ))}
        </ColListWrapper>
      ) : (
        <NotFound />
      )}
    </div>
  );
};

export default SelectedHousesList;

const MemoizedItem = memo(FirstLevelItem);

function FirstLevelItem({ data }) {
  const { name, houses } = data;

  return (
    <li>
      <Subtitle>{name}</Subtitle>
      <ColListWrapper>
        {houses.map((house) => (
          <Item.Memoized
            key={house.id}
            title={createHouseNumber(house)}
            note={getHouseType(house)}
            description={createRoomLabelByCount(house.acceptanceAddressCount)}
            iconComponent={HotelIcon}
          />
        ))}
      </ColListWrapper>
    </li>
  );
}
